// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderHeader_container__2Pmkw","highlight":"OrderHeader_highlight__so7rI"};